import React from "react";
import PropTypes from "prop-types";

const Action = props => {
    const { text, actionId, classes } = props;

    const handleOnClick = () => {
        const a = document.querySelector(`a[action-id='${actionId}']`);

        if (!a) {
            return;
        }

        a.click();
    };

    return (
        <a className={classes} onClick={handleOnClick} role="button">
            {text}
        </a>
    );
};

Action.propTypes = {
    text: PropTypes.string.isRequired,
    actionId: PropTypes.string.isRequired,
    classes: PropTypes.string
};

Action.defaultProps = {
    classes: ""
};

export default Action;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/components/action.js